module.exports = __webpack_public_path__ + "3a5e2e3d8af38b7f8e915818e4138c7f.svg";